import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M8.1838 32.0731H9.9968L27.4253 14.6552L25.6016 12.8315L8.1838 30.26V32.0731ZM31.8803 13.1467L27.1016 8.38507L30.4915 5.00586L35.251 9.76536L31.8803 13.1467ZM6.08984 34.167V29.3989L25.6208 9.86794L30.3889 14.636L10.8579 34.167H6.08984ZM26.5108 13.73L25.6016 12.8315L27.4253 14.6552L26.5108 13.73Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map